import Phaser from 'phaser';
import BootScene from './scenes/preloader';
import EDC from '../../shared/globals';
import store from '../../../../store';

function launch() {
  const difficultyConfig = store.getters['gameConfig/getGameConfig'];
  const defaultDifficulty = store.getters['games/getGameById']().sets[0].config;
  if (difficultyConfig && difficultyConfig.gameCode === 12) {
    EDC.Games.SequencingFrame.Config = { ...defaultDifficulty, ...difficultyConfig.config };
    this.difficulty = difficultyConfig.difficulty;
  } else {
    EDC.Games.SequencingFrame.Config = defaultDifficulty;
  }
  EDC.Games.SequencingFrame.GameData = EDC.Games.DaysOfWeek.GameData;

  return new Phaser.Game({
    type: Phaser.WEBGL,
    scale: {
      mode: Phaser.Scale.FIT,
      width: 1920,
      height: 1080,
    },
    parent: 'game',
    scene: [BootScene],
  });
}

export { launch };
